module.exports = __webpack_public_path__ + "cdb2b0e438c96621782dd84016ef5906.svg";